import { ListChecks, Users, Wrench } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const PAINS = [
  {
    icon: Users,
    title: "Referral dependency",
    desc: "One great month, then a dry quarter — because lead flow depends on who happens to call you.",
  },
  {
    icon: ListChecks,
    title: "List-building paralysis",
    desc: "Weeks lost scrolling LinkedIn with no clear parameters for what makes an account worth targeting.",
  },
  {
    icon: Wrench,
    title: "Tool setup friction",
    desc: "Domains, warmup, sequences, CRM columns — the tech stalls momentum before the first message goes out.",
  },
];

const Problem = () => (
  <section id="problem" data-testid="problem-section" className="scroll-mt-24 py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <Reveal>
        <Eyebrow>The problem</Eyebrow>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-6 max-w-4xl font-serif text-3xl font-medium leading-[1.18] tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Most founders know outbound could work, but never get past the
          list-building, copywriting and tool setup.
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-smoke">
          So referrals stay the only source of leads, and{" "}
          <em className="font-serif text-terra">revenue stays lumpy.</em>
        </p>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {PAINS.map((pain, i) => (
          <Reveal key={pain.title} delay={0.1 + i * 0.1} className="h-full">
            <div
              data-testid={`problem-card-${i + 1}`}
              className="group h-full rounded-2xl border border-line bg-white p-8 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-24px_rgba(26,26,25,0.3)]"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-full bg-terra-soft transition-colors group-hover:bg-terra">
                  <pain.icon className="h-5 w-5 text-terra transition-colors group-hover:text-white" />
                </span>
                <span className="font-serif text-3xl text-ink/10">0{i + 1}</span>
              </div>
              <h3 className="mt-8 font-serif text-xl text-ink">{pain.title}</h3>
              <p className="mt-2.5 text-sm leading-relaxed text-smoke">{pain.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Problem;
